var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceBgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 634,
    viewBox: "0 0 595 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.364,
    y: -33,
    width: 524,
    height: 580,
    rx: 143,
    transform: "rotate(15.5375 122.364 -33)",
    fill: "#EDF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceBgFull);
export default __webpack_public_path__ + "static/media/VoiceBGFull.bc2d28a2f93b5c2d3f0a81cb18267631.svg";
export { ForwardRef as ReactComponent };